import { foreignProps } from 'vessel/utils'

const cellProps = foreignProps({
  props: {
    width: {
      type: [String, Number],
      default: null
    },
    align: {
      type: String,
      default: 'left'
    },
    colspan: {
      type: [String, Number],
      default: null
    },
    rowspan: {
      type: [String, Number],
      default: null
    }
  }
})

export default {
  inheritAttrs: false,
  inject: ['table'],
  props: {
    ...cellProps.props,
    type: {
      type: String,
      default: 'value'
    },
    options: {
      type: Object,
      default: () => ({})
    },
    prop: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    sortable: {
      type: [Boolean, String],
      default: false
    },
    sortBy: {
      type: String,
      default: null
    },
    wrap: {
      type: Boolean,
      default: null
    },
    fixed: {
      type: [Boolean, String],
      default: false
    }
  },
  computed: {
    isFixed() {
      return this.fixed !== false
    },
    isLeft() {
      return this.isFixed && this.fixed != 'right'
    },
    isRight() {
      return this.isFixed && this.fixed == 'right'
    },
    noWrap() {
      return (this.wrap == null ? this.table.wrapColumn : this.wrap) == false
    },
    border() {
      return this.table.border
    },
    cellAttrs() {
      return cellProps.fetch(this.$props)
    }
  }
}
